import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { OneWebComponentsAngularModule } from '@one/angular';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
  selector: 'dl-resend-details',
  standalone: true,
  imports: [OneWebComponentsAngularModule],
  templateUrl: './resend-details.component.html',
  styleUrl: './resend-details.component.scss'
})
export class ResendDetailsComponent {

  public displayedColumns: string[] = [];
  public tableData: any[] = [];
  public contactNotificationId: any[] = [];
  public notificationId: any;
  @Output() closed = new EventEmitter<void>();

  sortInfo: { column: string, direction: string }[] = [{ column: 'CustomerName', direction: 'desc' }];

  @Input() public data: any;
  @Input() public resendVisible: boolean = false;

  constructor(
    public qnsbnService: QnSbnService,
    private snackBarNotification: SnackbarService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.data) {
      this.displayedColumns = this.data?.columnData || [];
      this.tableData = this.data?.tableData?.selectedItems || [];
      this.contactNotificationId = this.data?.tableData?.contactNotificationId || [];
      this.notificationId = this.data?.tableData?.notificationId;

      // set default sort
      this.sortInfo = [{ column: 'CreationDate', direction: 'desc' }];
    }
  }

  public onSort(column: string, value: string): void {
    const existingSortIndex = this.sortInfo.findIndex(sort => sort.column === column);
    if (existingSortIndex !== -1) {
      this.sortInfo.splice(existingSortIndex, 1);
    }
    if (value !== 'default') {
      this.sortInfo.push({ column, direction: value });
    }
    this.tableData = this.applySorting(this.tableData);
  }

  applySorting(data: any[]): any[] {
    const dataCopy = [...data];
    if (this.sortInfo.length > 0) {
      return dataCopy.sort((a, b) => {
        for (let i = this.sortInfo.length - 1; i >= 0; i--) {
          const { column, direction } = this.sortInfo[i];
          const aValue = a[column] ?? '';
          const bValue = b[column] ?? '';
          if (aValue < bValue) return direction === 'asc' ? -1 : 1;
          if (aValue > bValue) return direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return dataCopy;
  }

  public resend(): void {
    const resendApi = {
      NotificationId: this.notificationId,
      ContactNotificationIds: this.contactNotificationId,
    };

    const resendJson = JSON.stringify(resendApi);

    this.qnsbnService.postResendNotifications(resendJson).subscribe({
      next: (data: any) => {
        this.snackBarNotification.snackBarMessage('positive', 'Notification sent successfully');
        this.closed.emit();
      },
      error: (error: HttpErrorResponse) => {
        this.qnsbnService.httpErrorHandler(error, 'Email id is either not verified or wrong. Please correct and try again later.');
      }
    });
  }

  public onCancel(): void {
    this.closed.emit();
  }
}
